<template>
    <div class="row">
        <label class="font-poppins w-100 color-dark-blue">
            {{ required ? label + ' *' : label }}
            <i v-if="info && info.length > 0" class="fa fa-info-circle pointer color-primary" data-bs-toggle="tooltip"
               data-bs-placement="top" :title="info"></i>
        </label>
        <div class="col-12 form-check" v-for="(option, key) in options" :key="key">
            <input
                class="form-check-input"
                type="radio"
                :id="`${key}`"
                ref="input"
                v-model="selected"
                v-bind="$attrs"
                :value="`${key}`"
            >
            <label class="pr-2 form-check-label color-dark-blue font-poppins" :for="`${key}`"> {{ Lang.get(option) }}</label>
        </div>
        <form-error :error="error"></form-error>
    </div>
</template>

<script>
import FormError from "@/Shared/FormError";

export default {
    components: {FormError},
    inheritAttrs: false,
    props: {
        label: String,
        error: [String, Array],
        required: Boolean,
        value: String,
        info: String,
        options: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selected: this.value,
        }
    },
    watch: {
        selected() {
            this.$emit('input', this.selected)
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    },
}
</script>
